import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, SmartphoneIcon, ShieldCheckIcon, LockIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/8CHHMxsjG8uTN596kv5bDs/MOCKUP.png';
const badges = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-blush" data-id="element-156" data-mp="xb5s7ge82vws">
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-rose/10 blur-3xl" aria-hidden data-id="element-157" data-mp="sai3509k0p57" />
      <div className="absolute -bottom-32 -left-24 h-80 w-80 rounded-full bg-rose-soft/20 blur-3xl" aria-hidden data-id="element-158" data-mp="nb6l7nxgbdm1" />

      <div className="relative mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:py-20 lg:grid-cols-2 lg:items-center lg:gap-8" data-id="element-159" data-mp="3d2bn1yjw7fzr">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-160" data-mp="384jud2bfbpui">
          <p className="font-display text-lg font-semibold text-rose-deep text-center" data-id="element-161" data-mp="3o5j39ad4ljlt">💅 ESTÉTICA DIGITAL PRO™</p>
          <h1 className="mt-4 font-display text-4xl font-black leading-[1.05] text-ink sm:text-5xl lg:text-6xl text-center" data-id="element-162" data-mp="3e9frrdwdw8m7">
            Todo tu Instagram de Estética.
            <span className="block bg-gradient-to-r from-[#3e4ee9] via-[#9750d8] to-[#ff7396] bg-clip-text text-transparent text-center" data-id="element-163" data-mp="30gq4z7916zo1">Listo. Desde hoy.</span><img src={HERO_IMG} alt="Mega Pack Estética Digital Pro con seis tomos, plantillas y recursos para marketing de estéticas" className="h-full w-full object-cover" data-id="element-164" data-mp="2qk3hsbt8fwiu" />
          </h1>
          <p className="mt-5 text-ink/75 sm:text-lg text-[14px] text-center" data-id="element-165" data-mp="2hjf6hov84a9n">
            <strong className="font-semibold text-ink" data-id="element-166" data-mp="2hlj8205ngx6r">MegaPack 6 en 1.</strong> Convertí tu Instagram en una agenda llena.
          </p>
          <p className="mt-3 text-ink/60 text-center text-[12px]" data-id="element-167" data-mp="s2joo1a4k8lm">
            Estrategia y scripts listos para usar. Sin improvisar.
          </p>

          <div className="mt-5 flex justify-center lg:justify-start" data-id="element-168" data-mp="na09x0zpb7f8">
            <CTAButton href="#comprar" className="min-w-[21rem] whitespace-nowrap px-10" data-id="element-169" data-mp="id9r45wihxq4" />
          </div>

          <div className="mt-4 flex flex-wrap gap-2 items-start justify-center" data-id="element-170" data-mp="degcub9ei2ow">
            {badges.map(b => <span key={b.label} className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-ink/80 shadow-sm" data-id="element-171" data-mp="1azkwdtv2cmt9">
                <b.icon className="h-3.5 w-3.5 text-rose" data-id="element-172" data-mp="112g5xhu6q56n" />
                {b.label}
              </span>)}
          </div>

          <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-ink/60" data-id="element-173" data-mp="x02zssbj059c">
            {trust.map(t => <span key={t.label} className="inline-flex items-center gap-1.5" data-id="element-174" data-mp="3ltqc7blwotsz">
                <t.icon className="h-4 w-4 text-rose" data-id="element-175" data-mp="3hr3qlsftw548" />
                {t.label}
              </span>)}
            <span className="inline-flex items-center gap-1.5" data-id="element-176" data-mp="1xacfj35u5jt8">💳 Mercado Pago</span>
          </div>
        </motion.div>

        <motion.div className="relative" initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        ease: 'easeOut',
        delay: 0.15
      }} data-id="element-177" data-mp="21bfu7mc5d9sv">
          <div className="overflow-hidden rounded-3xl bg-white shadow-2xl shadow-indigo-300/30 ring-1 ring-indigo-100" data-id="element-178" data-mp="2g02jogvhnhxt">
            
          </div>
          <div className="absolute -bottom-5 left-1/2 flex -translate-x-1/2 items-center gap-2 rounded-full bg-white px-5 py-2.5 shadow-xl" data-id="element-179" data-mp="2kxc8bub1zpkl">
            <div className="flex text-rose" data-id="element-180" data-mp="2tzlds5rgssr4">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-181" data-mp="2txhdrywosdw4" data-mpi={i} />)}
            </div>
            <span className="text-sm font-bold text-ink" data-id="element-182" data-mp="uoaktrxkz5wv">4.9/5</span>
            <span className="text-xs text-ink/60" data-id="element-183" data-mp="zmluo2nvlgf3">+500 dueñas</span>
          </div>
        </motion.div>
      </div>

      <div className="relative border-t border-rose/10 bg-white/60" data-id="element-184" data-mp="4a2s9dsxexwg">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-10 gap-y-3 px-5 py-4 text-center text-sm text-ink/70" data-id="element-185" data-mp="3vi6yslwtccu7">
          <span data-id="element-186" data-mp="e8sd9fg4cygx"><strong className="text-ink" data-id="element-187" data-mp="e7haniyetwre">+500</strong> dueñas de estéticas confían</span>
          <span className="hidden h-4 w-px bg-rose/20 sm:block" data-id="element-188" data-mp="9b0eq2kyye3r" />
          <span data-id="element-189" data-mp="3hphd6il759xm"><strong className="text-ink" data-id="element-190" data-mp="3hrby3wwgx21p">6</strong> Tomos listos</span>
          <span className="hidden h-4 w-px bg-rose/20 sm:block" data-id="element-191" data-mp="3crfrrr0asyiz" />
          <span data-id="element-192" data-mp="3ct0jz9z545do"><strong className="text-ink" data-id="element-193" data-mp="3cp32stw4hnwf">4</strong> Bonos incluidos</span>
          <span className="hidden h-4 w-px bg-rose/20 sm:block" data-id="element-194" data-mp="3rgvdutovwfsc" />
          <span className="inline-flex items-center gap-1" data-id="element-195" data-mp="3motvcq14hstv"><strong className="text-ink" data-id="element-196" data-mp="3mo2dsj4d1vml">4.9/5</strong> calificación <StarIcon className="h-3.5 w-3.5 fill-rose text-rose" data-id="element-197" data-mp="2yyzl8g86uidb" /></span>
        </div>
      </div>
    </section>;
}